import { IntlTFunc } from 'next-intl';

import {
  CartItemCheckoutFragment,
  getFragmentData,
  ProductImageFragmentDoc
} from '@/fo/api/magento';

import { MappedProduct } from '../types';
import { attributesMapper } from '../utils/attributesMapper';
import { labelsMapper } from '../utils/labelsMapper';

/** Упрощенный маппер для товаров в чекауте с минимальным набором данных */
export const utilMapCartItemCheckoutData = (
  item: CartItemCheckoutFragment,
  t: IntlTFunc
): Partial<MappedProduct> => {
  const product = item.product;
  const imageData = product.image
    ? getFragmentData(ProductImageFragmentDoc, product.image)
    : null;

  const { labels } = attributesMapper(product.attributes, t);

  return {
    sku: product.sku || '',
    name: product.name || '',
    stockStatus: product.stockStatus || 'OUT_OF_STOCK',
    thumbnail: imageData
      ? {
          src: imageData.src || '',
          alt: imageData.alt || ''
        }
      : null,
    quantity: item.quantity,
    labels: labels ? labelsMapper(labels, []) : []
  };
};
